import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from './services/cookie-consent.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'NICT Computer Education';

  constructor(private cookieService: CookieConsentService) {}

  ngOnInit() {
    // If already accepted from before → enable tracking immediately
    if (this.cookieService.hasAccepted()) {
      this.enableTracking();
    }

    // 🔑 React to changes when user accepts/rejects
    this.cookieService.watchConsent().subscribe(value => {
      if (value === 'accepted') {
        this.enableTracking();
      }
      if (value === 'rejected') {
        this.disableTracking();
      }
    });
  }

  /** Called when user has consented */
  enableTracking() {
    // Prevent duplicate GA init
    if (document.getElementById('ga-script')) return;

    // Load GA
    const script1 = document.createElement('script');
    script1.id = 'ga-script';
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-L5PZN0E0SE';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    // script2.innerHTML = `
    //   window.dataLayer = window.dataLayer || [];
    //   function gtag(){dataLayer.push(arguments);}
    //   gtag('js', new Date());

    //   // Update consent to granted
    //   gtag('consent', 'update', {
    //     'ad_storage': 'granted',
    //     'analytics_storage': 'granted'
    //   });

    //   gtag('config', 'G-L5PZN0E0SE');
    // `;
    // document.head.appendChild(script2);

    // Load AdSense
    if (!document.getElementById('adsense-script')) {
      const adsense = document.createElement('script');
      adsense.id = 'adsense-script';
      adsense.async = true;
      adsense.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7506108289996762";
      adsense.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(adsense);
    }
  }

  /** Optional: Clear cookies / stop tracking when rejected */
  disableTracking() {
    // Tell GA/Adsense consent is denied again
    // if (typeof (window as any).gtag === 'function') {
    //   (window as any).gtag('consent', 'update', {
    //     'ad_storage': 'denied',
    //     'analytics_storage': 'denied'
    //   });
    // }
    console.log("Tracking disabled by user.");
  }
}
